import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import "@fortawesome/free-brands-svg-icons";
import "@fortawesome/free-brands-svg-icons";
import { first } from "lodash";
import { faCircleExclamation } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function InvoiceFieldsChile({
  handleBlurTaxID,
  errors,
  changeStoreField,
  invoiceFields,
  setInvoiceFields,
}) {
  const state = useSelector((state) => state);
  const { t } = useTranslation();

  const { billing, patterns, system_fields } = state.checkoutStore;

  const { doingRequest } = state.ui;

  const [showInvoiceFields, setShowInvoiceFields] = useState(false);

  useEffect(() => {
    if (billing && billing.taxid) {
      setShowInvoiceFields(billing.taxid.length > 8);
    }
  }, [billing]);

  function handleChangeTaxID(e) {
    const rut = e.target.value.replace(/[^\d]/g, "");

    // Check if the input length is valid
    if (rut === "" || rut.length < 9) {
      changeStoreField("taxid", e.target.value); // Return original RUT if length is not 9
    } else {
      // Format the RUT
      changeStoreField("taxid", rut.substring(0, 8) + "-" + rut.substring(8));
    }
  }

  return (
    <div className="mb-2 form-group">
      <div className="row">
        {/* Tax ID Field */}
        <div className="col-sm-6 pe-sm-1 mb-1">
          <div
            className={`input-placeholder floating-label-wrap mb-3 ${
              errors.taxid ? "error-div-highlight" : ""
            }`}
          >
            <label htmlFor="taxid" className="label-checkout">
              {t("information.cl-taxid")}{" "}
              {system_fields.taxid_required ? "*" : t("information.optional")}
            </label>
            <input
              type="text"
              required
              className="floating-label-field form-group floating-label-field--s1"
              id="taxid"
              disabled={doingRequest}
              placeholder={t("information.cl-taxid")}
              value={(billing != null && billing.taxid) || ""}
              onChange={(e) => handleChangeTaxID(e)}
              onBlur={handleBlurTaxID}
            />
          </div>
          <div
            className={`field-error ${errors.taxid ? "" : "hidden-error"} mt-n3`}
            style={{
              display: errors.taxid ? "flex" : "",
              alignItems: "center",
            }}
          >
            <FontAwesomeIcon
              icon={faCircleExclamation}
              style={{ paddingRight: "2px" }}
              size="sm"
              fixedWidth
            />
            {t(errors.taxid) +
              (errors.taxid != null
                ? errors.taxid.includes("empty") ||
                  errors.taxid.includes("invalid")
                  ? ""
                  : patterns.taxid_pattern
                : "")}
          </div>
        </div>

        {/* Razon Social Field (Appears only if showInvoiceFields is true) */}
        {showInvoiceFields && (
          <div className="col-sm-6 ps-sm-1 mb-3">
            <div className="floating-label-wrap form-group">
              <label htmlFor="razonsocial" className="label-checkout">
                {"Razon Social (Completar si necesita factura)"}
              </label>
              <input
                type="text"
                className="floating-label-field floating-label-field--s1"
                id="razonsocial"
                disabled={doingRequest}
                placeholder="Razon Social"
                onChange={(e) =>
                  setInvoiceFields({
                    ...invoiceFields,
                    "Razon Social": e.target.value,
                  })
                }
              />
            </div>
          </div>
        )}
      </div>

      {showInvoiceFields && (
        <div className="row">
          {/* Giro Field - Full Width */}
          <div className="col-12">
            <div className="floating-label-wrap form-group mb-3">
              <label htmlFor="giro" className="label-checkout">
                {"Giro (Completar si necesita factura)"}
              </label>
              <input
                type="text"
                className="floating-label-field floating-label-field--s1"
                id="giro"
                disabled={doingRequest}
                placeholder="Giro"
                onChange={(e) =>
                  setInvoiceFields({
                    ...invoiceFields,
                    Giro: e.target.value,
                  })
                }
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
